// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"c5efc765","77":"6458bf23","146":"1a573b96","167":"c4d11ad9","297":"9fa9a2a2","339":"b88e4a13","371":"527f0216","434":"79472a03","492":"86658351","494":"8b12cef7","629":"4a5fd1c4","758":"e72c6707","767":"3f185c4b","945":"fbb9bcf1","956":"66f17160"}[chunkId] + ".chunk.js";
};